import React from 'react';
import { createPortal } from 'react-dom';
import { QRCodeSVG } from 'qrcode.react';

export default function QrModal({ open, onClose }) {
  if (!open) return null;
  const url = window.location.origin + '/m';
  const isLocal = /^(localhost$|127\.|0\.0\.0\.0)/.test(window.location.hostname);
  return createPortal(
    <div className="qr-overlay" onClick={onClose}>
      <div className="qr-card" onClick={(e) => e.stopPropagation()}>
        <button className="qr-x" onClick={onClose} aria-label="Chiudi">✕</button>
        <div className="qr-title">App mobile</div>
        <div className="qr-sub">Inquadra col telefono per aprire l'app</div>
        <div className="qr-code"><QRCodeSVG value={url} size={220} level="M" /></div>
        <div className="qr-url">{url}</div>
        {isLocal && (
          <div className="qr-warn">⚠️ Stai usando <b>localhost</b>: dal telefono non è raggiungibile.
            Apri il gestionale dall'indirizzo di rete (IP LAN o dominio) e riapri il QR.</div>
        )}
      </div>
    </div>,
    document.body,
  );
}
